import axios from 'axios';
import { Logger } from 'UI-Dash-Commons-UI';


const TAG = 'MenuServiceProxy';

class MenuServiceProxy
{
    NAV_BAR_REQUEST_URL = '/o/v1/menu';

    fetchMenuSpec = ( successHandler, errorHandler ) =>
    {
        // Create target URL
        let targetUrl: string = window.location.pathname + window.location.search + window.location.hash;

        // Encode the URL
        targetUrl = encodeURIComponent( targetUrl );

        const requestUrl = `${this.NAV_BAR_REQUEST_URL}?u=${targetUrl}`;

        Logger.info( TAG, `Fetching menu spec from ${requestUrl}...` );

        axios
            .get( requestUrl )
            .then( response =>
                {
                    Logger.info( TAG, `Menu received` );

                    successHandler && successHandler( response );
                }
            )
            .catch( errorResponse =>
                {
                    Logger.error( TAG, `Failed to receive menu spec: ${JSON.stringify( errorResponse )}` );
                    errorHandler && errorHandler( errorResponse );
                }
            );
    };
}

export default MenuServiceProxy;
